// Partner Starter Pack Section JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Check if starter pack section exists
  const starterPackSection = document.querySelector('.partner-starter-pack-section');
  if (!starterPackSection) return;

  // Show bundle loader initially and run checks
  initStarterPackSection();
});

// Initialize starter pack section
function initStarterPackSection() {
  // Run initial check for starter bundle buttons
  checkStarterBundleButtons().finally(() => {
    // Buttons are ready after check completes
  });

  // Listen for cart update events to re-check starter bundle status
  document.querySelector('cart-form')?.addEventListener('cart-updated', async function() {
    await checkStarterBundleButtons();
  });

  // Handle Starter Bundle form submissions
  const starterBundleForms = document.querySelectorAll('.starter-bundle-form');
  starterBundleForms.forEach((bundleForm) => {
    bundleForm.addEventListener('submit', handleStarterBundleSubmit);
  });
}

// Handle starter bundle form submission
async function handleStarterBundleSubmit(e) {
  e.preventDefault();
  
  const bundleForm = e.target;
  const variantId = bundleForm.getAttribute('data-variant-id');
  const productTags = bundleForm.getAttribute('data-product-tags') || '';
  
  if (!variantId) {
    console.error('Starter bundle variant ID is missing');
    return;
  }
  
  // Get button elements for loading state
  const { submitBtn, loaderBtn, formBtnContainer } = getStarterBundleElements(bundleForm);
  
  // Show loading state
  if (submitBtn && loaderBtn && formBtnContainer) {
    submitBtn.classList.add('display-none');
    formBtnContainer.classList.add('no-click');
    loaderBtn.classList.remove('display-none');
  }
  
  try {
    // Check if partner fee exists in cart
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    
    let partnerFeeVariantId = null;
    
    // Find partner fee in cart by checking properties
    for (const item of cartData.items) {
      if (item.properties && item.properties._partner_fee === 'true') {
        partnerFeeVariantId = item.variant_id.toString();
        break;
      }
    }
    
    // If partner fee is not in cart, show alert and prevent adding
    if (!partnerFeeVariantId) {
      const alertMessage = KROWN?.settings?.locales?.partner_application_form?.alert_fee_required || 'Partner application fee must be added before Starter Pack';
      showPartnerAlert(alertMessage);
      // Restore button state
      if (submitBtn && loaderBtn && formBtnContainer) {
        loaderBtn.classList.add('display-none');
        submitBtn.classList.remove('display-none');
        formBtnContainer.classList.remove('no-click');
      }
      return;
    }
    
    // Real-time validation: Check if this starter bundle is already in cart
    // Only prevent if product has "disable-qty-in-cart" tag
    const productTagsList = productTags.split(',').map(tag => tag.trim());
    const hasDisableQtyTag = productTagsList.includes('disable-qty-in-cart');
    
    // If quantity is disabled by product tag, check if bundle already exists in cart
    if (hasDisableQtyTag) {
      let bundleInCart = false;
      for (const item of cartData.items) {
        // Check if this is a starter bundle (has _partner_fee_bundle but not _partner_fee_welcome_pack)
        const hasPartnerFeeBundle = item.properties && item.properties._partner_fee_bundle;
        const isWelcomePack = item.properties && item.properties._partner_fee_welcome_pack === 'true';
        
        if (item.variant_id.toString() === variantId.toString() && 
            hasPartnerFeeBundle && !isWelcomePack) {
          bundleInCart = true;
          break;
        }
      }
      
      // If bundle is already in cart, prevent submission
      if (bundleInCart) {
        console.log("starter bundle is already in cart - submission prevented");
        // Update button state to reflect current cart state
        if (submitBtn) {
          const blackTickIconElement = document.querySelector('.partner-black-tick-icon');
          const blackTickIcon = blackTickIconElement ? blackTickIconElement.innerHTML : '';
          const addedText = KROWN?.settings?.locales?.partner_application_form?.added || 'Added';
          submitBtn.innerHTML = addedText + ' ' + blackTickIcon;
          submitBtn.disabled = true;
          submitBtn.classList.add('btn--disabled');
          formBtnContainer.classList.add('no-click');
        }
        // Restore button state
        if (loaderBtn && formBtnContainer) {
          loaderBtn.classList.add('display-none');
          submitBtn.classList.remove('display-none');
        }
        return;
      }
    }
    
    // Build cart item
    const bundleItem = {
      id: variantId,
      quantity: 1,
    };
    
    // Add _partner_fee_bundle property since partner fee exists
    bundleItem.properties = {
      _partner_fee_bundle: partnerFeeVariantId,
    };
    
    document.dispatchEvent(new Event('checkout-buttons-section:show-loader', { bubbles: true }));
    // Add item to cart
    const response = await fetch(`${KROWN?.settings?.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [bundleItem] })
    });
    
    if (!response.ok) {
      const error = await response.json();
      console.error('Error adding starter bundle to cart:', error);
      throw new Error('Failed to add starter bundle to cart');
    }
    
    // Refresh cart and open sidebar
    await refreshCartForStarterPack();
    
    // Update starter bundle button states after adding to cart
    await checkStarterBundleButtons(true);
    
  } catch (error) {
    console.error('Error:', error);
    const errorMessage = KROWN?.settings?.locales?.partner_application_form?.alert_add_to_cart_failed || 'Failed to add product to cart. Please try again.';
    showPartnerAlert(errorMessage);
  } finally {
    // Button state will be updated by checkStarterBundleButtons() after cart refresh
    // But ensure loader is hidden in case of error
    if (loaderBtn && formBtnContainer) {
      loaderBtn.classList.add('display-none');
      submitBtn.classList.remove("display-none");
    }
  }
}

// Helper function to get starter bundle button elements
function getStarterBundleElements(bundleForm) {
  return {
    submitBtn: bundleForm.querySelector('button[type="submit"]'),
    loaderBtn: bundleForm.querySelector(".bundle-loader"),
    formBtnContainer: bundleForm.querySelector(".bundle-form-btn")
  };
}

// Check starter bundle buttons and update their state
async function checkStarterBundleButtons(isAddingToCart = false) {
  const bundleSection = document.querySelector(".bundle-section");
  if (!bundleSection) return;

  // Get all starter bundle forms
  const starterBundleForms = document.querySelectorAll(".starter-bundle-form");
  if (starterBundleForms.length === 0) return;

  if (!isAddingToCart) {
    // Ensure initial state: loader visible, submit button hidden
    starterBundleForms.forEach((bundleForm) => {
      const { submitBtn, loaderBtn, formBtnContainer } = getStarterBundleElements(bundleForm);
  
      if (submitBtn && loaderBtn && formBtnContainer) {
        // Show loader, hide submit button initially
        submitBtn.classList.add("display-none");
        formBtnContainer.classList.add("no-click");
        loaderBtn.classList.remove("display-none");
      }
    });
  }

  try {
    // Fetch cart data once
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();

    // Check each starter bundle button
    starterBundleForms.forEach((bundleForm) => {
      const variantId = bundleForm.getAttribute("data-variant-id");
      if (!variantId) return;

      const productTags = bundleForm.getAttribute("data-product-tags") || "";
      
      // Check if product has "disable-qty-in-cart" tag
      const productTagsList = productTags.split(',').map(tag => tag.trim());
      const hasDisableQtyTag = productTagsList.includes('disable-qty-in-cart');

      const { submitBtn, loaderBtn, formBtnContainer } = getStarterBundleElements(bundleForm);

      if (!submitBtn || !loaderBtn || !formBtnContainer) return;

      // If quantity is enabled (no disable tag), always show "Add to cart"
      if (!hasDisableQtyTag) {
        submitBtn.textContent =
          submitBtn.getAttribute("data-original-text") || "Add to cart";
        submitBtn.disabled = false;
        submitBtn.classList.remove("btn--disabled");
        formBtnContainer.classList.remove("no-click");
      } else {
        // If quantity is disabled by product tag, check if product exists in cart
        let bundleInCart = false;
        for (const item of cartData.items) {
          // Check if this is a starter bundle (has _partner_fee_bundle but not _partner_fee_welcome_pack)
          const hasPartnerFeeBundle =
            item.properties && item.properties._partner_fee_bundle;
          const isWelcomePack =
            item.properties &&
            item.properties._partner_fee_welcome_pack === "true";

          if (
            item.variant_id.toString() === variantId.toString() &&
            hasPartnerFeeBundle &&
            !isWelcomePack
          ) {
            bundleInCart = true;
            break;
          }
        }

        // Update button state
        if (bundleInCart) {
          // Bundle is in cart - show "Added" and disable
          const blackTickIconElement = document.querySelector(
            ".partner-black-tick-icon"
          );
          const blackTickIcon = blackTickIconElement
            ? blackTickIconElement.innerHTML
            : "";
          const addedText = KROWN?.settings?.locales?.partner_application_form?.added || 'Added';
          submitBtn.innerHTML = addedText + " " + blackTickIcon;
          submitBtn.disabled = true;
          submitBtn.classList.add("btn--disabled");
          formBtnContainer.classList.add("no-click");
        } else {
          // Bundle not in cart - show "Add to cart" normally
          submitBtn.textContent =
            submitBtn.getAttribute("data-original-text") || "Add to cart";
          submitBtn.disabled = false;
          submitBtn.classList.remove("btn--disabled");
          formBtnContainer.classList.remove("no-click");
        }
      }

      // Hide loader, show submit button
      loaderBtn.classList.add("display-none");
      submitBtn.classList.remove("display-none");
    });
  } catch (error) {
    console.error("Error checking starter bundle buttons:", error);
    // On error, default to "Add to cart" state for all buttons
    starterBundleForms.forEach((bundleForm) => {
      const { submitBtn, loaderBtn, formBtnContainer } = getStarterBundleElements(bundleForm);

      if (submitBtn && loaderBtn && formBtnContainer) {
        submitBtn.textContent =
          submitBtn.getAttribute("data-original-text") || "Add to cart";
        submitBtn.disabled = false;
        submitBtn.classList.remove("btn--disabled");
        loaderBtn.classList.add("display-none");
        submitBtn.classList.remove("display-none");
        formBtnContainer.classList.remove("no-click");
      }
    });
  }
}

// Show partner alert function
function showPartnerAlert(message, autoHideSeconds = 5) {
  const alertElement = document.getElementById('partner-alert');
  const messageElement = alertElement?.querySelector('.partner-alert__message');
  const closeButton = alertElement?.querySelector('.partner-alert__close');
  
  if (!alertElement || !messageElement) {
    console.warn('Partner alert element not found');
    return;
  }
  
  // Set message
  messageElement.textContent = message;
  
  // Set top position to 0
  alertElement.style.top = '0px';
  
  // Show alert
  alertElement.style.display = 'flex';
  
  // Scroll to top of page to ensure alert is visible (since it's fixed)
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  // Auto-hide after specified seconds
  let autoHideTimeout;
  if (autoHideSeconds > 0) {
    autoHideTimeout = setTimeout(() => {
      hidePartnerAlert();
    }, autoHideSeconds * 1000);
  }
  
  // Close button handler
  if (closeButton) {
    const closeHandler = () => {
      if (autoHideTimeout) {
        clearTimeout(autoHideTimeout);
      }
      hidePartnerAlert();
      closeButton.removeEventListener('click', closeHandler);
    };
    closeButton.addEventListener('click', closeHandler);
  }
}

// Hide partner alert function
function hidePartnerAlert() {
  const alertElement = document.getElementById('partner-alert');
  if (alertElement) {
    alertElement.style.display = 'none';
  }
}

// Refresh cart function for starter pack section (independent implementation)
async function refreshCartForStarterPack() {
  try {
    const response = await fetch('?section_id=helper-cart');
    const text = await response.text();
    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
    const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm')?.innerHTML;
    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal')?.innerHTML;

    const cartItems = document.getElementById('AjaxCartForm');
    if (cartItems && cartFormInnerHTML) {
      cartItems.innerHTML = cartFormInnerHTML;
      if (cartItems.ajaxifyCartItems) {
        cartItems.ajaxifyCartItems();
      }
    }

    document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
      const cartCount = cartItems?.querySelector('[data-cart-count]')?.textContent;
      if (cartCount) {
        elm.textContent = cartCount;
      }
    });

    document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
      const cartTotal = cartItems?.querySelector('[data-cart-total]')?.textContent;
      if (cartTotal) {
        elm.textContent = cartTotal;
      }
    });

    const cartSubtotal = document.getElementById('AjaxCartSubtotal');
    if (cartSubtotal && cartSubtotalInnerHTML) {
      cartSubtotal.innerHTML = cartSubtotalInnerHTML;
    }

    if (document.querySelector("[data-js-site-cart-sidebar]")) {
      document.querySelector("[data-js-site-cart-sidebar]").show();
    }

    if (document.querySelector('cart-recommendations')) {
      const cartRecommendations = document.querySelector('cart-recommendations');
      cartRecommendations.innerHTML = '';
      if (cartRecommendations.generateRecommendations) {
        cartRecommendations.generateRecommendations();
      }
    }

    // Refresh cart payment methods if available
    if (typeof window.refreshCartPaymentMethods === 'function') {
      await window.refreshCartPaymentMethods();
    }
  } catch (error) {
    console.error('Error refreshing cart for starter pack:', error);
  }
}

// ============================================================
// Enrollment Parameter & Scroll to Bundles
// ============================================================

// Add enrollment parameter to starter pack title links when clicking
(function() {
  const starterPackSection = document.querySelector('.partner-starter-pack-section');
  if (!starterPackSection) return;
  
  // Get template info from data attributes
  const templateSuffix = starterPackSection.getAttribute('data-template-suffix') || '';
  const pageHandle = starterPackSection.getAttribute('data-page-handle') || '';
  
  // Detect if enrollment or renewal page
  const isEnrollment = templateSuffix === 'partner-application-form' || (templateSuffix === '' && pageHandle === 'partner-application-form');
  const isRenewal = templateSuffix === 'partner-renewal-form' || (templateSuffix === '' && pageHandle === 'partner-renewal-form');
  
  // Only proceed if we're on enrollment or renewal page
  if (isEnrollment || isRenewal) {
    const enrollmentValue = isEnrollment ? 'true' : 'false';
    
    // Add click listeners to all starter pack title links
    document.addEventListener('DOMContentLoaded', function() {
      const bundleTitleLinks = document.querySelectorAll('.bundle-product-title-link');
      
      bundleTitleLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          const originalHref = link.getAttribute('href');
          if (originalHref) {
            try {
              const url = new URL(originalHref, window.location.origin);
              // Add or update enrollment parameter
              url.searchParams.set('enrollment', enrollmentValue);
              // Update the href
              link.setAttribute('href', url.toString());
            } catch (error) {
              console.error('Error updating link URL:', error);
            }
          }
        });
      });
    });
  }
})();

// Scroll to starter bundle section if scrollToBundles parameter is present
(function() {
  // Wait for page to fully load
  window.addEventListener('load', function() {
    // Check for scrollToBundles parameter in URL
    const urlParams = new URLSearchParams(window.location.search);
    const scrollToBundles = urlParams.get('scrollToBundles');
    
    if (scrollToBundles === 'true') {
      // Wait a bit more to ensure all content is rendered
      setTimeout(function() {
        const bundleSection = document.querySelector('.bundle-section');
        
        // Only scroll if section exists and is visible (has height)
        if (bundleSection) {
          const rect = bundleSection.getBoundingClientRect();
          const hasHeight = rect.height > 0;
          
          // Check if element is not hidden (display: none or visibility: hidden)
          const styles = window.getComputedStyle(bundleSection);
          const isNotHidden = styles.display !== 'none' && styles.visibility !== 'hidden';
          
          if (hasHeight && isNotHidden) {
            // Calculate scroll position with 100px offset
            const offset = 100;
            const elementPosition = bundleSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            // Smooth scroll to the section
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Remove parameter from URL (clean URL)
            urlParams.delete('scrollToBundles');
            const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
            window.history.replaceState({}, '', newUrl);
          }
        }
      }, 300); // Small delay to ensure content is fully rendered
    }
  });
})();

// ============================================================
// Shopify Theme Editor Integration
// Re-initialize JavaScript when sections are loaded/re-rendered
// ============================================================

function initStarterPackSectionDesignMode() {
  // Re-attach cart-updated listener if not already attached
  const cartForm = document.querySelector('cart-form');
  if (cartForm && !cartForm.hasAttribute('data-starter-pack-listener')) {
    cartForm.setAttribute('data-starter-pack-listener', 'true');
    
    cartForm.addEventListener('cart-updated', async function() {
      await checkStarterBundleButtons();
    });
  }
  
  // Re-attach form submit handlers
  const starterBundleForms = document.querySelectorAll('.starter-bundle-form');
  starterBundleForms.forEach((bundleForm) => {
    if (!bundleForm.hasAttribute('data-submit-listener')) {
      bundleForm.setAttribute('data-submit-listener', 'true');
      bundleForm.addEventListener('submit', handleStarterBundleSubmit);
    }
  });
}

// Listen for Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  // Check if this is the starter pack section
  if (event.target.querySelector('.partner-starter-pack-section')) {
    initStarterPackSectionDesignMode();
    checkStarterBundleButtons();
  }
});

// Run full logic in Shopify design mode (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  function runStarterPackDesignModeInit() {
    // Run checks
    checkStarterBundleButtons();
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runStarterPackDesignModeInit);
  } else {
    runStarterPackDesignModeInit();
  }
}

